import { Component, OnInit } from '@angular/core';
import { GroupService } from '../services/group.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  blockedActions:any = [];
  constructor(private groupService:GroupService) { 
    this.employeeBlockedModules();
    console.log(this.blockedActions,'const');
  }

  public loading = false;
  ngOnInit() {
    this.loading = true;
    this.blockedActions = [];
  }

  employeeBlockedModules(){
    this.groupService.blockedActions().subscribe(resp => {
      this.loading = false;
      this.blockedActions = resp;
      console.log(this.blockedActions);
    })
  }

}
